import React from "react";

import {Types} from "components";

import {Card, CardActions, CardContent} from "@material-ui/core";
import SignatureCanvas from "react-signature-canvas";
import {Button} from "reactstrap";
import moment from "moment";
import ObjectOverride from "components/ObjectOverride";


/**
 *  @property {Dispositions_Pendings_Object} state
 *  @property {object} model
 *  @property {Dispositions_Pendings_Properties} model.properties
 *  @property {Dispositions_Pendings_Is} model.is
 *  @property {Dispositions_Pendings_Has} model.has
 */

const signatureCanvasProps = {width: 675, height: 208, className: 'sigCanvas'};

export default class Signature30Form extends ObjectOverride {
	constructor(props) {
		super(props, Types.Dispositions_Pendings._name);
	}

	/** @type Object */
	sigPad30 = null;
	clear = (sigPad) => () => {
		this[sigPad].clear();
	};

	getSigPad30Ref = (ref) => {
		if (!ref) return;
		this.sigPad30 = ref;
	}
	// clearSigPad22Ref = () => this.clear('sigPad22')

	// noinspection JSUnusedLocalSymbols
	handleProcess(event, requestOverride) {
		this.state.signature_30 = this.sigPad30.getCanvas().toDataURL('image/png');
		this.state.signature_30_date = moment().local().format('YYYY-MM-DD HH:mm:ss');
		return true;
	}

	async handleSubmit() {
		if (this.sigPad30.isEmpty()) {
			this.setState({invalidSignature: true})
		} else {
			this.handleProcess(null, null);
			// let sigModel = new Api.BuildClass(Types.)
			this.props.updateFunction(this.state.signature_30, this.state.signature_30_date);
			this.props.afterSave();
		}
	}

	form = () => {
		return (
			<div>
				<p className="mdl-typography--text-center">
					<b>I certify that all of my responses in Section B of this form are still true, correct, and complete.</b>
				</p>
				<div className={'row'} style={{justifyContent: "center"}}>
					<div className="mdl-typography--text-center">
						<Card>
							<CardContent className="OnePage positionRelative">
								<span className={'signature'}/>
									{/*<img src={this.state.signature_30} alt={'Signature for Line 30'}/>*/}
									<div style={{backgroundColor: '#f2f3f4'}}>
										<SignatureCanvas penColor='black' canvasProps={signatureCanvasProps} minWidth={3}
										                 ref={this.getSigPad30Ref}/></div>

							</CardContent>
							 <CardActions className="OnePage signatureClearButtonContainer">
								<Button color="secondary" onClick={this.clear('sigPad30')}>Clear</Button>
							</CardActions>
						</Card>
					</div>
				</div>
			</div>
		)
	};

}

